import { render } from "./subcategorylist.vue?vue&type=template&id=e10f1992"
import script from "./subcategorylist.vue?vue&type=script&lang=js"
export * from "./subcategorylist.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__